import React from 'react';
import Component from '@vfuk/core-bottom-tray';
const BottomTray = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default BottomTray;
